import {useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useEffect, useRef, useState} from 'react'

export const useScroller = ({
    items,
    itemWidth,
    defaultNumberOfItems = {base: 2, md: 5, lg: 6},
    scrollContainerId
}) => {
    const scrollRef = useRef()

    const [scrollPosition, setScrollPosition] = useState(0)
    const numberOfItems = useBreakpointValue(defaultNumberOfItems, {
        fallback: 6
    })
    const totalScrolls = Math.ceil(items?.length / numberOfItems)

    useEffect(() => {
        const container = document.getElementById(scrollContainerId)
        const handleScroll = () => {
            const itemWidth = container.firstChild.offsetWidth
            const currentScroll = Math.round(container.scrollLeft / itemWidth)
            setScrollPosition(Math.ceil(currentScroll / numberOfItems))
        }

        if (container) {
            container.addEventListener('scroll', handleScroll)
            return () => container.removeEventListener('scroll', handleScroll)
        }
    }, [itemWidth, numberOfItems])

    const scroll = (direction = 1) =>
        scrollRef.current?.scrollBy({
            top: 0,
            left: direction * scrollRef.current.clientWidth,
            behavior: 'smooth'
        })

    return {scroll, scrollRef, totalScrolls, scrollPosition}
}
